
  import { Component, Vue } from 'vue-property-decorator';
  import TheDialogError from "@/modules/Popup/components/AppErrorPopup.vue";
  import AppConfirmPopup from "@/modules/Popup/components/AppConfirmPopup.vue";
  import PayByCard from "@/modules/Payment/components/PayByCard.vue";
  import BalancePopup from "@/modules/Payment/components/BalancePopup.vue";
  import BankAccountDocument from "@/modules/CarList/components/BankAccountDocument.vue";
  import MovementsChangePopup from "@/modules/Report/Movements/components/changePopup/MovementsChangePopup.vue";
  import FeedbackPopup from "@/modules/Support/components/FeedbackPopup.vue";
  import AntiTheftCarsPopup from "@/modules/CarList/components/AntiTheftComponents/AntiTheftCarsPopup.vue";
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import CorpPopup from "@/modules/Corps/components/corpPopup/CorpPopup.vue";
  import EventsLogPopup from "@/shared/EventsLog/components/EventsLogPopup.vue";
  import AppMediaPopup from "@/shared/AppMediaPopup/components/AppMediaPopup.vue";
  import CashPayPopup from "@/modules/Popup/components/special/CashPayPopup.vue";
  import DecodeMoneyPopup from "@/modules/Popup/components/special/DecodeMoneyPopup.vue";
  import InputCarNumberPopup from "@/modules/Popup/components/special/InputCarNumberPopup.vue";
  import DeviceStatsPopup from "@/modules/DeviceStats/components/DeviceStatsPopup.vue";
  import CarPopup from "@/modules/Car/components/CarPopup.vue";
  import AccountPopup from "@/modules/Profile/components/accounts/AccountPopup.vue";
  import CookieBannerPopup from "@/shared/CookieBanner/components/CookieBannerPopup.vue";
  import BankIframePopup from "@/modules/Payment/components/BankIframePopup.vue";
  import ConfirmArchivePopup from "@/modules/Car/components/ConfirmArchivePopup.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import AccountLogPopup from "@/modules/Profile/components/accounts/AccountLogPopup.vue";
  import LoginSelectCorpPopup from "@/modules/Auth/components/LoginSelectCorpPopup.vue";

  @Component({
    components: {
      LoginSelectCorpPopup,
      AccountLogPopup,
      ConfirmArchivePopup,
      BankIframePopup,
      CookieBannerPopup,
      AccountPopup,
      DeviceStatsPopup,
      InputCarNumberPopup,
      DecodeMoneyPopup,
      CashPayPopup,
      AppMediaPopup,
      EventsLogPopup,
      TheDialogError,
      AppConfirmPopup,
      PayByCard,
      BalancePopup,
      BankAccountDocument,
      CarPopup,
      MovementsChangePopup,
      FeedbackPopup,
      AntiTheftCarsPopup,
      CorpPopup,
    },
  })
  export default class AppDialogContainer extends Vue {

    get storeState(): IAppState { return this.$store.state; }
    get dialogs(): IDialogStoreState { return this.storeState.dialog; }
    get carDialogDisplay() { return this.storeState.car.displayPopup; }

  }
